/**
 * The intercompany route table (design C3 §5.9, §6.6).
 *
 * Exported as `INTERCO_ROUTES` and mounted by **P9** in
 * `web/src/router/index.ts`.
 */

import type { RouteRecordRaw } from 'vue-router'

import { INTERCO_PERMISSIONS } from '@/modules/interco/permissions'

export const INTERCO_ROUTES: RouteRecordRaw[] = [
  {
    path: '/interco/pairs',
    name: 'interco-pairs',
    component: () => import('@/modules/interco/PairsView.vue'),
    meta: { titleKey: 'interco.routeTitles.pairs', permission: INTERCO_PERMISSIONS.pairRead },
  },
  {
    path: '/interco/match',
    name: 'interco-match',
    component: () => import('@/modules/interco/MatchBoardView.vue'),
    meta: { titleKey: 'interco.routeTitles.match', permission: INTERCO_PERMISSIONS.pairRead },
  },
  {
    path: '/interco/statements',
    name: 'interco-statements',
    component: () => import('@/modules/interco/StatementsView.vue'),
    meta: { titleKey: 'interco.routeTitles.statements', permission: INTERCO_PERMISSIONS.pairRead },
  },
  {
    path: '/interco/ageing',
    name: 'interco-ageing',
    component: () => import('@/modules/interco/AgeingReportView.vue'),
    meta: { titleKey: 'interco.routeTitles.ageing', permission: INTERCO_PERMISSIONS.pairRead },
  },
]
